import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Header from '../../../../../../../components/Stake/header';
import * as gamerStakeActions from '../../../../../../../actions/gamer-stake-actions-polygon';
import GamerIcon from '../../../../../../../assets/images/GAMER.png';
import cn from 'classnames';
import stylesParent from '../../../../../../../components/Stake/frame/frame.module.scss';
import styles from './styles.module.scss';
import Button from '@material-ui/core/Button';
import { useGetTheme } from '../../../../../../../hooks/useGetTheme';
import Checkbox from '../../../../../../../components/checkbox';

const StakeAttention = () => {
  const dispatch = useDispatch();
  const colors = useGetTheme();
  const [checked, setChecked] = useState(false);

  return (
    <>
      <Header
        icon={GamerIcon}
        title={'GAMER-Staking'}
        onClickBack={() => dispatch(gamerStakeActions.stakeSettings())}
      />
      <div className={cn(stylesParent.cardContent)} style={{ color: colors.text }}>
        <div className={styles.title}>Attention</div>
        <div className={styles.description}>
          I understand that the $GAMER single asset staking will be used for the Gamestation
          Leaderboard to gain Gamestation IGO allocation opportunities and initially will have 0%
          APR reward for the first month.
        </div>
        <Checkbox
          checked={checked}
          onChange={() => setChecked(!checked)}
          className={styles.checkbox}
        >
          <span>*</span> I have read and agreed.
        </Checkbox>
        <Button
          onClick={() => dispatch(gamerStakeActions.stakeDetails())}
          variant='contained'
          color='secondary'
          className={styles.button}
          disabled={!checked}
        >
          Next
        </Button>
      </div>
    </>
  );
};

export default StakeAttention;
